<template>
    <div>
        <InitialLoading :init-loading='loading' />
        <v-container v-if='!loading'>
            <v-row>
                <v-col>
                    <h3 class='d-block font-weight-bold flex-grow-1 mb-4'>پروفایل</h3>
                </v-col>
            </v-row>
            <v-row v-if='user' no-gutters justify='space-between' class='mb-3'>
                <v-col cols='12' sm='5'>
                    <div class='d-flex'>
                        <div v-if='!loading' class='flex-grow-1 user-profile'>
                            <v-sheet
                                class='add-user-photo'
                                dark
                                @click='uploadFileImage'
                            >
                                <v-icon size='sm' dark>mdi-camera-plus-outline</v-icon>
                            </v-sheet>
                            <User :user='user' v-if='!uploadDialog' show-phone />
                        </div>
                        <div class='flex-grow-1 text-center' v-else>
                            <h4>لطفا صبر کنید...</h4>
                        </div>
                    </div>
                </v-col>
            </v-row>
            <v-row v-if='user'>
                <v-col cols='12' md='5'>
                    <v-card class='mx-auto' outlined>
                        <v-list two-line>
                            <v-list-item-group
                                color='primary'
                            >
                                <v-list-group>
                                    <template v-slot:activator>
                                        <v-list-item-icon class='mb-4 ml-4'>
                                            <v-icon>mdi-account</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-title>
                                            <span>اطلاعات پروفایل</span>
                                        </v-list-item-title>
                                    </template>
                                    <v-list-item
                                        link
                                        @click='uploadFileImage'
                                    >
                                        <v-list-item-icon class='mb-4 mx-4'>
                                            <v-icon>mdi-camera-plus</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-title> عکس پروفایل</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item
                                        v-if='photo'
                                        link
                                        @click='openDeletePhotoDialog'
                                    >
                                        <v-list-item-icon class='mb-4 mx-4'>
                                            <v-icon>mdi-camera-off</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-title>حذف تصویر پروفایل</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item
                                        link
                                        :to="{name:'EditUser'}">
                                        <v-list-item-icon class='mb-4 mx-4'>
                                            <v-icon>mdi-account-cog</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-title> اطلاعات هویتی</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item link
                                                 :to="{name:'EditAccount'}">
                                        <v-list-item-icon class='mb-4 mx-4'>
                                            <v-icon>mdi-account-cash</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-title> اطلاعات مالی</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item link
                                                 :to="{name:'AuthenticationDocumentsForm'}"
                                    >
                                        <v-list-item-icon class='mb-4 mx-4'>
                                            <v-icon>mdi-camera-front</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-title>احراز هویت</v-list-item-title>
                                    </v-list-item>
                                </v-list-group>
                                <v-list-group>
                                    <template v-slot:activator>
                                        <v-list-item-icon class='mb-4 ml-4'>
                                            <v-icon>mdi-wallet</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-title>کیف پول</v-list-item-title>
                                    </template>
                                    <v-list-item link
                                                 :to='{name:"MyWallet"}'>
                                        <v-list-item-icon class='mb-4 mx-4'>
                                            <v-icon>mdi-wallet-plus</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-title>موجودی</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item
                                        link
                                        :to="{
                                        name:'Invoices',
                                        query: {ref: 'user',}
                                    }"
                                    >
                                        <v-list-item-icon class='mb-4 mx-4'>
                                            <v-icon>mdi-calendar-clock-outline</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-title>صورت حساب‌های من</v-list-item-title>
                                    </v-list-item>
                                </v-list-group>
                                <!--                            <v-list-group>-->
                                <!--                                <template v-slot:activator>-->
                                <!--                                    <v-list-item-icon class='mb-4 ml-4'>-->
                                <!--                                        <v-icon>mdi-home-analytics</v-icon>-->
                                <!--                                    </v-list-item-icon>-->
                                <!--                                    <v-list-item-title>-->
                                <!--                                        <span>گزارشات فعالیت</span>-->
                                <!--                                    </v-list-item-title>-->
                                <!--                                </template>-->
                                <!--                                <v-list-item link-->
                                <!--                                             :to='{name:"MyAds"}'>-->
                                <!--                                    <v-list-item-icon class='mb-4 mx-4'>-->
                                <!--                                        <v-icon>mdi-storefront-outline</v-icon>-->
                                <!--                                    </v-list-item-icon>-->
                                <!--                                    <v-list-item-title>آگهی‌های من</v-list-item-title>-->
                                <!--                                </v-list-item>-->
                                <!--                                <v-list-item-->
                                <!--                                    link-->
                                <!--                                    :to='{name:"InvitedUsers"}'-->
                                <!--                                >-->
                                <!--                                    <v-list-item-icon class='mb-4 mx-4'>-->
                                <!--                                        <v-icon>mdi-account-plus-outline</v-icon>-->
                                <!--                                    </v-list-item-icon>-->
                                <!--                                    <v-list-item-title>کاربران دعوت شده</v-list-item-title>-->
                                <!--                                </v-list-item>-->
                                <!--                                <v-list-item-->
                                <!--                                    link-->
                                <!--                                    :to='{name:"FavoriteAds"}'-->
                                <!--                                >-->
                                <!--                                    <v-list-item-icon class='mb-4 mx-4'>-->
                                <!--                                        <v-icon>mdi-star</v-icon>-->
                                <!--                                    </v-list-item-icon>-->
                                <!--                                    <v-list-item-title>آگهی‌های نشان‌دار شده</v-list-item-title>-->
                                <!--                                </v-list-item>-->
                                <!--                                <v-list-item link-->
                                <!--                                             :to="{name:'Messages'}">-->
                                <!--                                    <v-list-item-icon class='mb-4 mx-4'>-->
                                <!--                                        <v-icon>mdi-email</v-icon>-->
                                <!--                                    </v-list-item-icon>-->
                                <!--                                    <v-list-item-title>پیغام ها</v-list-item-title>-->
                                <!--                                </v-list-item>-->
                                <!--                                <v-list-item link-->
                                <!--                                             :to='{name:"Notifications"}'-->
                                <!--                                >-->
                                <!--                                    <v-list-item-icon class='mb-4 mx-4'>-->
                                <!--                                        <v-badge-->
                                <!--                                            v-if='store.notifications.notifications.newItem'-->
                                <!--                                            color='error'-->
                                <!--                                            overlap-->
                                <!--                                            dot-->
                                <!--                                            bordered-->
                                <!--                                            offset-x='8px'-->
                                <!--                                            offset-y='6px'-->
                                <!--                                        >-->
                                <!--                                            <v-icon>mdi-bell-alert-outline</v-icon>-->
                                <!--                                        </v-badge>-->
                                <!--                                        <v-icon v-else>mdi-bell-alert-outline</v-icon>-->
                                <!--                                    </v-list-item-icon>-->
                                <!--                                    <v-list-item-title>اعلان های دریافتی</v-list-item-title>-->
                                <!--                                </v-list-item>-->
                                <!--                            </v-list-group>-->
                                <v-list-group>
                                    <template v-slot:activator>
                                        <v-list-item-icon class='mb-4 ml-4'>
                                            <v-icon>mdi-contacts</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-title>
                                            <span>مخاطبین</span>
                                        </v-list-item-title>
                                    </template>
                                    <v-list-item
                                        :to='{name:"ContactsList"}'
                                    >
                                        <v-list-item-icon class='mb-4 mx-4'>
                                            <v-icon>mdi-account-box-multiple</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-title>لیست مخاطبین</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item
                                        :to="{name:'AddContacts'}"
                                    >
                                        <v-list-item-icon class='mb-4 mx-4'>
                                            <v-icon>mdi-account-plus</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-title>اضافه کردن</v-list-item-title>
                                    </v-list-item>
                                </v-list-group>
                                <v-list-group>
                                    <template v-slot:activator>
                                        <v-list-item-icon class='mb-4 ml-4'>
                                            <v-icon>mdi-account-tie</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-title>
                                            <span>شخصی سازی</span>
                                        </v-list-item-title>
                                    </template>
                                    <v-list-item
                                    >
                                        <v-switch
                                            v-model='theme'
                                            @change='changeTheme'
                                            inset
                                            persistent-hint
                                        />
                                        <v-list-item-title>تغییر تم</v-list-item-title>
                                    </v-list-item>
                                </v-list-group>
                                <v-list-group>
                                    <template v-slot:activator>
                                        <v-list-item-icon class='mb-4 ml-4'>
                                            <v-icon>mdi-shield-lock</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-title>
                                            <span>امنیت</span>
                                        </v-list-item-title>
                                    </template>
                                    <!--                                todo:check and complete-->
                                    <v-list-item link v-if='false'>
                                        <v-list-item-icon class='mb-4 mx-4'>
                                            <v-icon>mdi-message-processing</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-title>SMS</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item
                                        :to='{name:"ActiveDevices"}'>
                                        <v-list-item-icon class='mb-4 mx-4'>
                                            <v-icon>mdi-devices</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-title>دستگاهای متصل</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item
                                        :to='{name:"ChangePassword"}'>
                                        <v-list-item-icon class='mb-4 mx-4'>
                                            <v-icon>mdi-lock-reset</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-title>تغییر رمزعبور</v-list-item-title>
                                    </v-list-item>
                                    <!--                                todo:check and complete-->
                                    <v-list-item link v-if='false'>
                                        <v-list-item-icon class='mb-4 mx-4'>
                                            <v-icon>mdi-shield-check</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-title>تایید دو مرحله‌ای</v-list-item-title>
                                    </v-list-item>
                                    <!--                                todo:check and complete-->
                                    <v-list-item link v-if='false'>
                                        <v-list-item-icon class='mb-4 mx-4'>
                                            <v-icon>mdi-cancel</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-title>غیر فعال کردن حساب</v-list-item-title>
                                    </v-list-item>
                                </v-list-group>
                                <v-list-group v-if='packages.length > 0'>
                                    <template v-slot:activator>
                                        <v-list-item-icon class='mb-4 ml-4'>
                                            <v-icon>mdi-auto-fix</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-title>
                                            <span>فعال سازی امکانات پیشرفته</span>
                                        </v-list-item-title>
                                    </template>
                                    <v-list-item
                                        v-for='item in paidFeatures'
                                        :key='item.key'
                                        :to='{
                                    name:"BuyFeature",
                                    params:{paidFeature_key: item.key},
                                    query: {cbUrl: pageUrl}
                                }'
                                    >
                                        <v-list-item-icon class='mb-4 ml-4'>
                                            <v-icon>mdi-package</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-title>{{ item.title }}</v-list-item-title>
                                    </v-list-item>
                                </v-list-group>
                                <v-list-group>
                                    <template v-slot:activator>
                                        <v-list-item-icon class='mb-4 ml-4'>
                                            <v-icon>mdi-exit-run</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-title>
                                            <span class='red--text'>خروج</span>
                                        </v-list-item-title>
                                    </template>
                                    <v-list-item @click='logout = true'>
                                        <v-list-item-icon class='mb-4 mx-4'>
                                            <v-icon>mdi-logout</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-title>خروج از حساب کاربری</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item @click='logoutAll = true'>
                                        <v-list-item-icon class='mb-4 mx-4'>
                                            <v-icon>mdi-logout-variant</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-title>خروج همه دستگاه ها از این حساب کاربری</v-list-item-title>
                                    </v-list-item>
                                </v-list-group>
                            </v-list-item-group>
                        </v-list>
                        <v-divider></v-divider>
                    </v-card>
                </v-col>
            </v-row>
            <v-dialog
                class='ma-1'
                width='500'
                v-model='uploadDialog'
                transition='dialog-bottom-transition'
            >
                <v-form @submit.prevent.stop='submitPhotos'>
                    <v-card>
                        <v-card-text>
                            <div class='d-flex justify-center'>
                                <div
                                    v-if='photo'
                                    class='elevation-5 thumb-image'
                                    @click='uploadDialog = true'
                                >
                                    <v-img
                                        v-if='!uploadDialogLoading && !userImageLoadError'
                                        @error='imageLoadError'
                                        width='100%'
                                        height='100%'
                                        :src='`${store.public_url}/${photo}`'
                                    >
                                        <template v-slot:placeholder>
                                            <v-row
                                                class='fill-height ma-0'
                                                align='center'
                                                justify='center'
                                            >
                                                <v-progress-circular
                                                    indeterminate
                                                    color='primary'
                                                ></v-progress-circular>
                                            </v-row>
                                        </template>
                                    </v-img>
                                    <v-icon
                                        color='red'
                                        style='position: absolute; top: 0; left: 0'
                                        @click='deletePhoto'
                                    >
                                        mdi-close
                                    </v-icon>
                                </div>
                                <v-file-input
                                    v-else
                                    v-model.lazy='photo'
                                    hide-input
                                    class='upload-file-btn'
                                    color='primary'
                                    accept='image/*'
                                    prepend-icon='mdi-plus'
                                    @change='uploadFiles'
                                >
                                </v-file-input>
                            </div>
                        </v-card-text>
                        <v-divider />
                        <v-card-actions>
                            <v-btn
                                block
                                color='primary'
                                :loading='loadingSubmitPhotos'
                                :disabled='loadingSubmitPhotos'
                                type='submit'
                            >
                                ثبت
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-form>
            </v-dialog>
            <v-dialog
                v-model='uploadDialogLoading'
                persistent
            >
                <v-card>
                    <v-row
                        class='fill-height ma-0 text-center'
                        align='center'
                        justify='center'
                    >
                        <v-col cols='12'>
                            <p>
                                در حال بارگذاری فایل
                            </p>
                            <v-progress-circular
                                indeterminate
                            ></v-progress-circular>
                        </v-col>
                    </v-row>
                </v-card>
            </v-dialog>
            <v-dialog
                max-width='420'
                v-model='deletePhotoDialog'
            >
                <v-card>
                    <v-card-title tag='h4'>تایید حذف تصویر پروفایل</v-card-title>
                    <v-card-actions>
                        <v-btn
                            @click='deletePhotoDialog=false'
                            outlined
                        >
                            انصراف
                        </v-btn>
                        <v-spacer />
                        <v-btn
                            @click='submitDeleteUserPhoto'
                            color='primary'
                            :loading='loadingDeleteUserPhoto'
                            :disabled='loadingDeleteUserPhoto'
                        >
                            تایید
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-model='logout' max-width='420' persistent>
                <v-card>
                    <v-card-title class='subtitle-1'>خروج</v-card-title>
                    <v-card-text>
                        با تایید شما، خروج از حساب کاربری از این دستگاه انجام میشود. آیا مطمئن هستید؟
                    </v-card-text>
                    <v-card-actions>
                        <v-btn
                            color='primary'
                            :loading='loadingLogout'
                            @click='logOut'
                        >
                            تایید
                        </v-btn>
                        <v-spacer />
                        <v-btn
                            outlined
                            @click='logout = false'
                        >
                            انصراف
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-model='logoutAll' max-width='420' persistent>
                <v-card v-if='!submitVerifyCodeForm'>
                    <v-card-title class='subtitle-1'>خروج از تمامی دستگاه ها</v-card-title>
                    <v-card-text>
                        با تایید شما، خروج تمامی دستگاه های مرتبط از این حساب کاربری انجام میشود. آیا مطمئن هستید؟
                    </v-card-text>
                    <v-divider />
                    <v-card-actions>
                        <v-btn
                            color='primary'
                            :loading='loadingLogoutAll'
                            @click='logOutAll'
                        >
                            تایید
                        </v-btn>
                        <v-spacer />
                        <v-btn
                            outlined
                            @click='logoutAll = false'
                        >
                            انصراف
                        </v-btn>
                    </v-card-actions>
                </v-card>

                <v-card v-else>
                    <v-card-title class='subtitle-1'>ارسال کد تایید خروج از تمامی حساب ها</v-card-title>
                    <v-card-text class='ltr'>
                        <v-otp-input
                            autofocus
                            :disabled='loadingSubmitCode'
                            v-model='code'
                            length='6'
                            type='number'
                            @finish='submitVerifyLogoutAllToken'
                        ></v-otp-input>
                        <v-overlay absolute :value='loadingSubmitCode'>
                            <v-progress-circular
                                indeterminate
                                color='primary'
                            ></v-progress-circular>
                        </v-overlay>
                    </v-card-text>
                    <v-divider />
                    <v-card-actions>
                        <v-spacer />
                        <v-btn
                            outlined
                            @click='logoutAll = false'
                        >
                            انصراف
                        </v-btn>
                    </v-card-actions>
                </v-card>

            </v-dialog>
        </v-container>
    </div>
</template>

<script>
    import axios from 'axios';
    import User from '@/components/User.vue';
    import { mapActions, mapState } from 'vuex';
    import InitialLoading from '@/components/initialLoading';

    export default {
        name: 'Profile',
        props: {
            message: String
        },
        components: {
            InitialLoading,
            User
        },
        data: () => ({
            logout: false,
            logoutAll: false,
            loadingLogout: false,
            loadingLogoutAll: false,
            submitVerifyCodeForm: false,
            loadingSubmitCode: false,

            theme: false,
            authentication_documents: [],
            code: null,

            userImageLoadError: false,
            uploadDialog: false,
            deletePhotoDialog: false,


            loading: false,
            loadingInvoices: false,
            uploadDialogLoading: false,
            loadingSubmitPhotos: false,
            loadingDeleteUserPhoto: false,

            photo: null,
            apartment_id: '',

            user: {
                account: {
                    cardNumber: '',
                    shebaNumber: '',
                    accountNumber: ''
                },
                manager: ''
            },

            packages: [],
            paidFeatures: [],
            pageUrl: window.location.pathname
        }),
        methods: {
            async fetchPaidFeature() {
                await axios
                    .get(`/api/paidFeatures`)
                    .then(res => {
                        this.paidFeatures = res.data.paidFeatures;
                    })
                    .catch(err => {
                        console.error(err);
                    });
            },
            async fetchPackageList() {
                await axios
                    .get(`/api/packages`)
                    .then(res => {
                        this.packages = res.data.packages;
                    })
                    .catch(err => {
                        console.error(err);
                    });
            },
            async logOut() {
                this.loadingLogout = true;
                await axios.post('/api/users/me/logout', {})
                    .then(async () => {
                        this.showNavigation(false);
                        this.setToken('');
                        this.loadingLogout = false;
                        this.$cookies.remove('token');
                        this.$cookies.remove('user_phone');
                        sessionStorage.removeItem('user');
                        sessionStorage.removeItem('roles');
                        this.setUser('');
                        await this.$router.push({ name: 'Login' });

                    })
                    .catch(err => {
                        this.loadingLogout = false;
                        console.error(err);
                        this.showNavigation(false);
                        this.setToken('');
                        this.$cookies.remove('token');
                        this.$router.push({ name: 'Login' });
                        this.$cookies.remove('user_phone');
                        sessionStorage.removeItem('user');
                        sessionStorage.removeItem('roles');
                        this.setUser('');
                    });
            },

            async logOutAll() {
                this.loadingLogoutAll = true;

                await axios
                    .get('/api/users/me/logout_all')
                    .then(async () => {
                        this.$snackbar.showMessage({
                            color: 'success',
                            timeout: 3000,
                            content: 'کد تایید خروج از تمامی حساب ها به شماره تلفن همراه شما ارسال شد'
                        });
                        this.submitVerifyCodeForm = true;
                    })
                    .catch(err => {
                        console.error(err);
                        let content = `خطا در سرور \n ${err.response ? err.response.data.error : ''}`;

                        if (err.response.status === 401) {
                            content = 'نیاز به ورود مجدد به حساب';
                            this.$router.push({ name: 'Login' });
                        }
                        this.$snackbar.showMessage({
                            color: 'red',
                            timeout: 7000,
                            content
                        });
                    });
                this.loadingLogoutAll = false;
            },
            async submitVerifyLogoutAllToken() {
                this.loadingSubmitCode = true;
                await axios
                    .post('/api/users/me/verify_logout_all', { code: this.code })
                    .then(() => {
                        this.showNavigation(false);
                        this.setToken('');
                        this.$cookies.remove('token');
                        this.$router.push({ name: 'Login' });
                        this.$cookies.remove('user_phone');
                        sessionStorage.removeItem('user');
                        sessionStorage.removeItem('roles');
                        this.setUser('');
                    })
                    .catch(err => {
                        console.error(err);

                        let content = `خطا در سرور \n ${err.response ? err.response.data.error : ''}`;
                        if (err.response && err.response.status === 403) content = 'کد وارد شده صحیح نمیباشد';
                        this.code = null;

                        this.$snackbar.showMessage({
                            color: 'red',
                            timeout: 5000,
                            content
                        });
                    });
                this.loadingSubmitCode = false;
            },

            changeTheme(value) {
                this.$cookies.set('theme', value);
                this.theme = value;
                this.$vuetify.theme.dark = this.$cookies.get('theme') === 'true';
            },
            openDeletePhotoDialog() {
                this.deletePhotoDialog = true;
            },
            async submitDeleteUserPhoto() {
                this.loadingDeleteUserPhoto = true;
                await axios
                    .put(`api/users/photo`, { photo: null })
                    .then(async () => {
                        this.user.photo = null;
                        await sessionStorage.setItem('user', JSON.stringify(this.user));
                        sessionStorage.setItem('user_id', this.user._id);
                        this.deletePhotoDialog = false;
                        this.$snackbar.showMessage({
                            content: 'تصویر پروفایل کاربری حذف شد',
                            color: 'success'
                        });
                    })
                    .catch(err => {
                        console.error(err);
                    });
                this.loadingDeleteUserPhoto = false;
            },
            uploadFileImage() {
                this.photo = this.store.user.photo;
                this.uploadDialog = true;
            },
            imageLoadError() {
                this.photo = [];
                this.userImageLoadError = true;
            },
            isEmpty(obj) {
                return Object.keys(obj).length === 0;
            },
            async submitPhotos() {
                this.loadingSubmitPhotos = true;
                await axios
                    .put(
                        `api/users/photo`,
                        {
                            photo: this.photo
                        }
                    )
                    .then(async ({ data }) => {
                        this.userImageLoadError = false;
                        this.user.photo = data.photo;
                        await sessionStorage.setItem('user', JSON.stringify(this.user));
                        sessionStorage.setItem('user_id', this.user._id);
                        this.loadingSubmitPhotos = false;
                        this.uploadDialog = false;
                        this.idPhotoDialog = false;
                    })
                    .catch((err) => {
                        this.loadingSubmitPhotos = false;
                        console.error(err.message);
                    });
            },
            deletePhoto() {
                this.photo = null;
            },
            uploadFiles() {
                if (this.photo) {
                    const formData = new FormData();
                    formData.append('photo', this.photo);
                    const imgList = ['image/png', 'image/jpeg', 'image/gif'];
                    if (imgList.includes(this.photo.type)) {
                        if (this.photo.size < 20971520) {
                            this.uploadDialogLoading = true;
                            axios
                                .post(
                                    `api/upload/photos/user--${this.user._id}`,
                                    formData
                                )
                                .then(async (res) => {
                                    this.photo = res.data.url;
                                    this.uploadDialogLoading = false;
                                })
                                .catch((err) => {
                                    this.photo = [];
                                    let message = 'تصویر بارگذاری نشد';
                                    this.$snackbar.showMessage({ content: message, color: 'warning' });
                                    this.uploadDialogLoading = false;
                                    console.error(err);
                                });
                        } else {
                            this.photo = [];
                            this.$snackbar.showMessage({
                                content: 'حداکثر حجم فایل ۲۰۰ مگابایت میباشد',
                                color: 'warning'
                            });
                        }

                    } else {
                        this.photo = [];
                        this.$snackbar.showMessage({
                            content: 'فرمت فایل نامعتبر میباشد \n فرمت های قابل قبول عبارت اند از \n ' +
                                'jpeg, png, gif',
                            color: 'warning'
                        });
                    }
                }
            },

            async fetchData() {
                this.loading = true;
                await axios
                    .get('/api/users/account')
                    .then(res => {
                        this.user.account = res.data.account || {};
                        this.user.manager = res.data.manager;
                        this.loading = false;
                    }).catch(() => {
                        this.user.account = {};
                        this.loading = false;
                    });

            },
            checkPermission(apartment_id) {
                this.role = this.store.roles[apartment_id];
            },
            ...mapActions([
                'showNavigation', 'setToken', 'setUser', 'showBreadCrumbs', 'setBreadCrumbsTemp'
            ])
        },
        async created() {
            await this.fetchPaidFeature();
            await this.fetchPackageList();
            this.theme = this.$vuetify.theme.dark = this.$cookies.get('theme') === 'true';
            sessionStorage.removeItem('redirectTo');
            await this.setBreadCrumbsTemp({
                key: 'profile',
                value: {
                    text: `پروفایل`,
                    href: `/Profile/`
                }
            });

        },
        async updated() {
            await this.showBreadCrumbs(['profile']);
        },
        mounted: async function() {
            this.loading = true;
            this.user = this.store.user;
            this.photo = this.store.user.photo;
            this.authentication_documents = this.user.authentication_documents;
            if (this.store.user.manager) {
                await this.fetchData();
            }
            this.loading = false;
        },
        computed: {
            ...mapState({ store: state => state })
        }
    };
</script>

<style lang='scss'>
    .user-profile {
        position: relative;

        .add-user-photo {
            border-radius: 50px;
            position: absolute;
            padding: 5px;
            bottom: 0;
            z-index: 1;
            right: 0;
            display: flex;
            justify-content: center;
            align-items: center;

            > i {
                font-size: 15px;
            }
        }
    }

    .thumb-image {
        margin: 2.5px;
        position: relative;
        width: 130px;
        height: 130px;
        flex: initial;
        justify-content: center;
        align-items: center;
        border: 2px solid gray;
        border-radius: 5px;
        padding: 0;
    }

    .upload-file-btn {
        width: 130px;
        height: 130px;
        flex: initial;
        justify-content: center;
        align-items: center;
        border: 2px solid gray;
        border-radius: 5px;
        padding: 0;

        .v-input__prepend-outer {
            margin: 0 !important;
        }

        .v-icon {
            font-size: 125px;
        }
    }

</style>